/**
 * bb-add-to-cart-helper.js — Spec 051 (Phase 1)
 *
 * Overrides the legacy global `addToCartWithSellingPlan(variantId, sellingPlanId)`
 * helper so subscription add-to-cart actions open the cart drawer instead of
 * navigating to /checkout.
 *
 * Background:
 *   Several templates (subscription-plans-annual-hero, etc.) define this helper
 *   inline via custom_liquid blocks. Those inline versions hard-redirect to
 *   /checkout, which skips the drawer and prevents upsell/downsell.
 *
 * Strategy:
 *   Re-define `window.addToCartWithSellingPlan` AFTER the inline scripts have
 *   run. Buttons call the helper on user click, so any redefinition that lands
 *   before user interaction will win. This file is loaded `defer` from
 *   theme.liquid so it executes after parser-blocking inline scripts.
 *
 * Mirrors the post-add behavior in addon-bundler.js / bb-subscribe-direct.js.
 */
(function () {
  'use strict';

  function tryOpenCartDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      try { drawer.open(); return true; } catch (e) { /* fall through */ }
    }
    var trigger = document.querySelector('#cart-icon-bubble')
      || document.querySelector('button[aria-controls*="CartDrawer"]')
      || document.querySelector('[data-drawer-id*="cart"]');
    if (trigger) {
      trigger.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
      return true;
    }
    return false;
  }

  function refreshCartDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function') {
      // Drawer's own listener on cart-update will re-render; nothing to do.
      return;
    }
  }

  // Known selling-plan IDs → plan label. Keep in sync with template settings.
  // Source: templates/index.json + templates/collection.template2.json (Spec 051).
  var PLAN_TYPE_BY_SELLING_PLAN = {
    '7286849743': 'annual',
    '7286784207': 'quarterly'
  };

  function resolvePlanType(sellingPlanId, hint) {
    if (hint && typeof hint === 'string') { return hint; }
    if (sellingPlanId == null) { return 'subscription'; }
    var key = String(sellingPlanId);
    return PLAN_TYPE_BY_SELLING_PLAN[key] || 'subscription';
  }

  window.addToCartWithSellingPlan = function (variantId, sellingPlanId, planTypeHint) {
    if (!variantId) { return; }

    // Guard: check variant availability AND bb_sold_out tag before attempting cart add.
    // Sold-out variants (inventory_policy: deny + qty 0) or bb_sold_out-tagged products
    // should not be purchasable regardless of Shopify inventory configuration.
    fetch('/variants/' + variantId + '.js')
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (variant) {
        if (variant && variant.available === false) {
          console.warn('[bb-add-to-cart-helper] Blocked add for sold-out variant:', variantId);
          return;
        }
        // Check product tags via the product endpoint
        if (variant && variant.product_id) {
          return fetch('/products/' + variant.product_id + '.js')
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (product) {
              if (product && product.tags && product.tags.indexOf('bb_sold_out') !== -1) {
                console.warn('[bb-add-to-cart-helper] Blocked add for bb_sold_out product:', product.handle);
                return;
              }
              window._bbDoAddToCart(variantId, sellingPlanId, planTypeHint);
            });
        }
        window._bbDoAddToCart(variantId, sellingPlanId, planTypeHint);
      })
      .catch(function () {
        // If the availability check fails, allow through (fail open) so
        // legitimate purchases are not silently blocked.
        window._bbDoAddToCart(variantId, sellingPlanId, planTypeHint);
      });
  };

  window._bbDoAddToCart = function (variantId, sellingPlanId, planTypeHint) {
    var body = {
      items: [{
        id: Number(variantId) || variantId,
        quantity: 1
      }]
    };
    if (sellingPlanId) {
      var planType = resolvePlanType(sellingPlanId, planTypeHint);
      body.items[0].selling_plan = Number(sellingPlanId) || sellingPlanId;
      body.items[0].properties = { _bb_subscription: planType, _bb_plan_type: planType };
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (res) { return res.json(); })
      .then(function () {
        // Notify Dawn / other listeners so the drawer + bubble update.
        try {
          document.documentElement.dispatchEvent(new CustomEvent('cart-update', { bubbles: true }));
        } catch (e) { /* noop */ }
        refreshCartDrawer();
        if (!tryOpenCartDrawer()) {
          window.location.assign('/cart');
        }
      })
      .catch(function (err) {
        console.error('[bb-add-to-cart-helper] add failed:', err);
      });
  };
})();
